import { Navigate, useParams } from 'react-router-dom';
import EasyMode from '../../../components/easy-mode/EasyMode';
import useEasyModeFeatureFlag from '../../../hooks/useEasyModeFeatureFlag';

// Easy Mode is Diamond-tier only; anyone else who lands on the URL is sent to the classic editor
const EasyModeCasePage = () => {
  const isEasyModeEnabled = useEasyModeFeatureFlag();
  const { caseId } = useParams();

  if (!isEasyModeEnabled) {
    return <Navigate to={`/case/edit/${caseId}`} replace />;
  }

  return <EasyMode />;
};

export default EasyModeCasePage;
